import {
  Group,
  Button,
  Menu,
  ActionIcon,
  useMantineTheme,
} from '@mantine/core';
import { Stepper } from '../../molecules';
import { useSetup } from './use-setup';
import { Container, LeftColumn, RightColumn, StepWrapper } from './styles';
import { useEffect } from 'react';
import { MdOutlineLanguage } from 'react-icons/md';
import { useStore } from '@/store';

import { NavigateModal } from '../../../core/organisms/navigate-modal';

export const Setup = () => {
  const theme = useMantineTheme();
  const { init, step, handlePrevious, renderStep, handleLanguageChange, opId } =
    useSetup();
  const Step = renderStep();
  const [setHeader, clearHeader] = useStore(({ ui }) => [
    ui.setHeader,
    ui.clearHeader,
  ]);

  useEffect(() => {
    init();
  }, []);

  // Hosted in the shared header (rightAction) rather than floating with its
  // own absolute positioning, so it lays out next to whatever else the
  // header renders on the right (e.g. the Help button) instead of
  // overlapping it.
  useEffect(() => {
    setHeader({
      rightAction: (
        <Menu shadow="md" position="bottom-end">
          <Menu.Target>
            <ActionIcon
              variant="default"
              size="md"
              sx={{ border: `1px solid ${theme.colors.gray[3]}` }}
            >
              <MdOutlineLanguage size="1rem" color={theme.colors.gray[7]} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={handleLanguageChange} data-lang="en">
              English
            </Menu.Item>
            <Menu.Item onClick={handleLanguageChange} data-lang="nl">
              Nederlands
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      ),
    });
    return () => clearHeader();
    // Register once on mount only. handleLanguageChange is recreated every
    // render (not memoized in useSetup), so including it here would re-run
    // this effect every render — each run calls setHeader(), which updates
    // the store and re-renders this component, which recreates the
    // function again: an infinite loop. It doesn't close over anything
    // that changes, so capturing it once at mount is safe.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!opId) {
    return;
  }

  return (
    <Container>
      <NavigateModal />
      <LeftColumn>
        <StepWrapper>
          <Step>
            {(progress, disabled) => (
              <Group position="right">
                {(step === 0 || step === 2 || step === 3 || step === 4) && (
                  <Button disabled={disabled} onClick={progress}>
                    Confirm
                  </Button>
                )}
              </Group>
            )}
          </Step>
        </StepWrapper>
      </LeftColumn>

      <RightColumn>
        <Group position="center">
          <Stepper step={step} />
        </Group>
      </RightColumn>
    </Container>
  );
};
